import {
  AlertDialog,
  AlertDialogProps,
  CalendarStage,
  JFormik,
  Stage,
} from '@centerpiece/components';
import { ContactComponent } from 'components/ContactComponent';
import { useProjectContext } from 'contexts/project.context';
import { useRef, useState } from 'react';
import {
  project,
  usePatchStageMutation,
  useLazyGetStageQuery,
  subscribeStage,
  useGetProjectStagesQuery,
} from 'store/api';
import { Outcome, Stage as StageModel } from 'store/api/models';
import { incompleteChild } from 'utils/project.utils';
import { useTrackWorkFlow, useGetWorkFlowForm } from 'utils/workflow.utils';
import * as Yup from 'yup';

export const ProjectViewStage = ({
  stage,
  nextStage,
  props,
  setWorkflowDetails,
  setAlertDetails,
  setOpenContact,
  calendar = false,
}: {
  stage: StageModel;
  nextStage: StageModel;
  props: any;
  setAlertDetails: Function;
  setWorkflowDetails: Function;
  setOpenContact: Function;
  calendar?: boolean;
}) => {
  const {
    id: project_id,
    project,
    disabled,
    template,
    currentStage,
    project_stages,
    refetchProject,
    afterSave,
    patchProject,
    itemsRef,
    completeChildren,
  } = useProjectContext();
  const alertFormRef = useRef<any>(null);

  const [patchStage, patchStageResult] = usePatchStageMutation();

  const trackWorkFlow = useTrackWorkFlow({
    win_loss: project?.type_r?.win_loss,
    setOpenContact,
  });
  const getWorkflowForm = useGetWorkFlowForm({
    setOpenContact,
  });

  const thisStage = project_stages?.find(s => s.id === stage?.stage_r?.id);
  const outcomes: Outcome[] =
    thisStage?.outcomes?.map(o => ({
      ...o,
      stage_r: { ...thisStage },
      awarded: thisStage?.awarded,
    })) || [];
  const workflowForm = getWorkflowForm(stage);

  const alertConfirm = async ({
    values,
    callback,
    outcome,
  }: {
    values: any;
    callback: Function;
    outcome: Outcome | null;
  }) => {
    if (values) {
      // const values = alertFormRef.current.values;
      // add workflow form to project
      callback();
      await patchStage({
        id: stage?.id,
        outcome: outcome?.id || null,
        form: {
          workflow: {
            ...values,
            stakeholders: values.stakeholders
              ?.filter((s: any) => s.contact)
              ?.map((s: any) =>
                s.contact?.type === 'organization'
                  ? {
                      ...s,
                      contact: null,
                      organization: { ...s.contact },
                    }
                  : {
                      ...s,
                      contact: {
                        ...s.contact.contact_r,
                        organization_r: {
                          ...s.contact.organization_r,
                        },
                      },
                    }
              ),
            competitors: values.competitors
              ?.filter((s: any) => s.contact)
              ?.map((s: any) =>
                s.contact?.type === 'organization'
                  ? {
                      ...s,
                      contact: null,
                      organization: { ...s.contact },
                    }
                  : {
                      ...s,
                      contact: {
                        ...s.contact.contact_r,
                        organization_r: {
                          ...s.contact.organization_r,
                        },
                      },
                    }
              ),
          },
        },
      } as any);
      if (outcome?.state) {
        await patchProject({
          id: Number(project_id),
          state: outcome?.state,
        } as any); //mark project completed
      } else if (project.state === 1 && !outcome) {
        await patchProject({
          id: Number(project_id),
          state: 3,
        } as any); //mark project in progress
      }
      await refetchProject();
      await afterSave();
      setWorkflowDetails({
        open: false,
      } as any);
    }
  };
  const workflow = async (outcome: Outcome | null, callback: Function) => {
    const workflowForm = trackWorkFlow({
      outcome,
      nextStage,
      projectTitle: project?.title || '',
    });
    if (workflowForm) {
      setWorkflowDetails({
        open: true,
        initialValues: workflowForm.initialValues || {},
        validationSchema: workflowForm.validationSchema,
        form: workflowForm.form,
        // form: (
        //   <JFormik
        //     formRef={alertFormRef}
        //     initialValues={workflowForm.initialValues || {}}
        //     validationSchema={workflowForm.validationSchema}
        //     form={workflowForm.form}
        //   />
        // ),
        button: 'SUBMIT',
        title: workflowForm.title,
        content: workflowForm.content,
        onConfirm: async (values: any) => {
          alertConfirm({ values, callback, outcome });
        },
        onClose: () =>
          setWorkflowDetails({
            open: false,
          } as any),
        // alternate: (
        //   <ContactComponent
        //     title={'Create contact'}
        //     close={() => setOpenContact({ open: false })}
        //     {...openContact}
        //   />
        // ),
        // openAlternate: openContact.open,
        // closeAlternate: () => setOpenContact({ open: false }),
      });
    } else {
      callback();
      await patchStage({
        id: stage?.id,
        outcome: outcome?.id || null,
      } as any);
      if (outcome?.state) {
        await patchProject({
          id: Number(project_id),
          state: outcome?.state,
        } as any); //mark project completed
      } else if (project.state !== 3 && !outcome) {
        await patchProject({
          id: Number(project_id),
          state: 3,
        } as any); //mark project in progress
      } else {
        refetchProject();
      }
      afterSave();
    }
  };
  const StageRender = calendar ? CalendarStage : Stage;
  return (
    <>
      {/* <AlertDialog
        {...workflowDetails}
        // alternate={
        //   <ContactComponent
        //     title={'Create contact'}
        //     close={() => setOpenContact({ open: false })}
        //     {...openContact}
        //   />
        // }
        // openAlternate={openContact.open}
        // closeAlternate={() => setOpenContact({ open: false })}
      /> */}
      <StageRender
        key={`stage-${stage.item}`}
        documentId={`stage-${stage.item}`}
        ref={(el: any) => {
          (itemsRef.current as any)[`stage-${stage.item}`] = el;
        }}
        {...props?.props}
        showDetails={!props?.expanded}
        data={stage}
        onStatusInfo={
          workflowForm
            ? () => {
                setAlertDetails({
                  open: true,
                  // initialValues: workflowForm.initialValues || {},
                  // validationSchema:workflowForm.validationSchema,
                  // form: workflowForm.form,
                  button: 'SUBMIT',
                  form: (
                    <JFormik
                      disabled={true}
                      formRef={alertFormRef}
                      initialValues={workflowForm.initialValues || {}}
                      validationSchema={workflowForm.validationSchema}
                      form={workflowForm.form}
                    />
                  ),
                  title: workflowForm.title,
                  content: workflowForm.content,
                  onEdit: () => {
                    setAlertDetails({ open: false });
                    setWorkflowDetails({
                      open: true,
                      initialValues: workflowForm.initialValues || {},
                      validationSchema: workflowForm.validationSchema,
                      form: workflowForm.form,
                      button: 'SUBMIT',
                      title: workflowForm.title,
                      content: workflowForm.content,
                      onConfirm: async (values: any) => {
                        await patchStage({
                          id: stage?.id,
                          outcome: stage.outcome || null,
                          form: {
                            workflow: {
                              ...values,
                              stakeholders: values.stakeholders
                                ?.filter((s: any) => s.contact)
                                ?.map((s: any) =>
                                  s.contact?.type === 'organization'
                                    ? {
                                        ...s,
                                        contact: null,
                                        organization: { ...s.contact },
                                      }
                                    : {
                                        ...s,
                                        contact: {
                                          ...s.contact.contact_r,
                                          organization_r: {
                                            ...s.contact.organization_r,
                                          },
                                        },
                                      }
                                ),
                              competitors: values.competitors
                                ?.filter((s: any) => s.contact)
                                ?.map((s: any) =>
                                  s.contact?.type === 'organization'
                                    ? {
                                        ...s,
                                        contact: null,
                                        organization: { ...s.contact },
                                      }
                                    : {
                                        ...s,
                                        contact: {
                                          ...s.contact.contact_r,
                                          organization_r: {
                                            ...s.contact.organization_r,
                                          },
                                        },
                                      }
                                ),
                            },
                          },
                        } as any);
                        refetchProject();
                        afterSave();
                        setWorkflowDetails({
                          open: false,
                        } as any);
                      },
                      onClose: () => {
                        setWorkflowDetails({
                          open: false,
                        } as any);
                      },
                    });
                  },
                  onClose: () => {
                    setAlertDetails({ open: false });
                  },
                });
              }
            : undefined
        }
        onStatusChange={async (outcome: Outcome | null, callback: Function) => {
          let incomplete = incompleteChild(props?.children);
          if (outcome?.id && incomplete) {
            setAlertDetails({
              open: true,
              onClose: () => {},
              title: `Can't complete stage`,
              content: `To complete the stage you must complete all children items. Would you like to automatically complete all child items?`,
              confirmLabel: 'Complete children items',
              onConfirm: async () => {
                await completeChildren(props?.children);
                await workflow(outcome, callback);
              },
            });
            return;
          } else {
            await workflow(outcome, callback);
          }
        }}
        statuses={outcomes}
        onDateChange={(newValue: any) =>
          ({
            id: stage?.id,
            project: Number(project_id),
            due_date: newValue.end || null,
            start_date: newValue.start || null,
          } as any)
        }
        reloadParent={() => {
          refetchProject();
          afterSave();
        }}
        patchMutation={usePatchStageMutation}
        lazyQuery={useLazyGetStageQuery}
        subscription={subscribeStage}
        subscriptionParams={{
          id: stage?.id,
        }}
        disabled={disabled}
        template={template}
        active={currentStage?.id == stage?.id}
      />
    </>
  );
};
